import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';
import CashFlowData from '../../components/Cashflow/EstimateList';

const AccountSaleEstimate =() => {
    return(
      <>
        <Breadcrumb />
        <CashFlowData accountType={"Invoices"} type={'sale-estimate'} />
      </>
    );
};
export default AccountSaleEstimate;